export interface IOrganizationShortDTO {

    id?: number | null
    code?: string | null
    fullName?: string | null
}

export class OrganizationShortModel implements IOrganizationShortDTO {

  constructor(model?: Partial<IOrganizationShortDTO>) {
    if (model) {
      this.id = model.id;
      this.code = model.code;
      this.fullName = model.fullName;
    }
  }

  id?: number | null;
  code?: string | null;
  fullName?: string | null;

}
